module.exports = __webpack_public_path__ + "static/media/erdbprepared.3887d39b.svg";